import type { PropsWithChildren } from "react";
import { createContext, useContext, useState } from "react";

type UploadQueueVisibilityContextType = {
  isQueueVisible: boolean;
  setQueueVisible: (visible: boolean) => void;
};

const UploadQueueVisibilityContext =
  createContext<UploadQueueVisibilityContextType>({
    isQueueVisible: false,
    setQueueVisible: () => {},
  });

export function UploadQueueVisibilityProvider({ children }: PropsWithChildren) {
  const [isQueueVisible, setQueueVisible] = useState(false);
  return (
    <UploadQueueVisibilityContext.Provider
      value={{ isQueueVisible, setQueueVisible }}
    >
      {children}
    </UploadQueueVisibilityContext.Provider>
  );
}

export function useUploadQueueVisibility() {
  return useContext(UploadQueueVisibilityContext);
}
